import { render, staticRenderFns } from "./3_patientData.vue?vue&type=template&id=9aaf8c1a&scoped=true&"
import script from "./3_patientData.vue?vue&type=script&lang=js&"
export * from "./3_patientData.vue?vue&type=script&lang=js&"
import style0 from "./3_patientData.vue?vue&type=style&index=0&id=9aaf8c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aaf8c1a",
  null
  
)

export default component.exports